define('GameDayCore/GDModel/enums/baseball/PlayerTypes',{
    BATTER: "batter",
    PITCHER: "pitcher",
    B: "b",
    P: "p",
    HOME: "home",
    AWAY: "away",
    CATCHER: "c",
    PITCHER_DEFENSE: "p",
    FIRST_BASE: "b1",
    SECOND_BASE: "b2",
    THIRD_BASE: "b3",
    SHORTSTOP: "ss",
    LEFT_FIELD: "lf",
    CENTER_FIELD: "cf",
    RIGHT_FIELD: "rf",
    DH: "dh",
    POS_ARRAY: ["p", "c", "b1", "b2", "ss", "b3", "lf", "cf", "rf"]
});
